<template>
  <div class="abbody">
    <div class="abcent privacy-cent">
      <div class="privacy-tit">隐私协议</div>
      <div class="privacy-tit2">
        <strong>1. 简介</strong>
      </div>
      <p>欢迎使用 Jldatas！</p>
      <p>
        为践行帮助所有人推动跨境电商商业发展的使命，深圳海轮电商咨询有限公司旗下产品（统称为“海轮”）收集并处理大量信息。本隐私政策旨在帮助您更好地了解我们如何收集、使用和存储个人信息—无论您是商家、使用
        Jldatas
        产品、应用程序或服务（统称为“服务”）的最终用户、在使用我们的技术的ERP进行数据分析、自发货订单处理，以及任何相关的服务或产品，即表示您同意隐私政策中的条款以及 Jldatas服务条款中的适用部分。
      </p>
      <p>
        我们可能会不时更新此隐私政策以反映我们的隐私相关做法的变更，或是出于其他运营、方面或监管方面的原因进行更新。如果我们对本隐私政策进行重大更改，我们将通过在本网站上发布修订后的政策以及在适当情况下通过其他方式来向您发出此类更改通知。如在这些更改发布后继续使用本网站或客服服务，即表示您同意修订后的政策。
      </p>
      <div class="privacy-tit2">
        <strong>2.我们从商家的客户处收集哪些信息？用于何种用途？</strong>
      </div>
      <p>
        我们收集商家的客户的姓名、邮箱、收货地址、电话号码、下达的订单的相关信息我们使用这些信息来为商家提供服务，包括支持和处理订单、风险和欺诈筛查、身份验证和支付方面的服务。我们还使用这些信息来改进服务。
      </p>
      <p>
        我们使用您提供的部分个人信息来执行某种程度的自动决策，例如，我们使用某些个人信息（例如收件人地区或地址或邮寄方式详细信息）来在短时间内自动对订单匹配运输方式提高订单自动化处理能力。
      </p>
      <p>
        我们使用您提供这份数据，想物流服务商申请物流发货面单为服务用户的目的，本应用可能通过使用您的个人信息，向您提供您感兴趣的信息，包括但不限于向您发出产品和服务信息。
      </p>
      <p>
        本产品服务不会向任何无关第三方提供、出售、出租、分享或交易您的个人信息，除非事先得到您的许可，或该第三方和本应用（含本应用关联公司）单独或共同为您提供服务。
      </p>
      <p>
        本产品服务亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播您的个人信息。任何本应用平台用户如从事上述活动，一经发现，本应用有权立即终止与该用户的服务协议。
      </p>
      <div class="privacy-tit2">
        <strong>3.我们在什么时候收集这些信息？</strong>
      </div>
      <p>
        我们在为我们的商家进行处理自发货订单的过程中，需要从Amazon等第三方平台通过接口获取订单的详细数据过程中收集这些信息。
      </p>
      <div class="privacy-tit2">
        <strong>4.我们在什么时候以及出于什么原因与第三方共享这些信息？</strong>
      </div>
      <p>我们还可能在以下情况共享您的个人信息：</p>
      <p>经您事先同意，向第三方披露；</p>
      <p>为提供您所要求的产品和服务，而必须和第三方分享您的个人信息；</p>
      <p>
        为了防止、调查或处理非法活动、疑似欺诈行为、对任何人的人身安全构成潜在威胁的情况以及违反服务条款或任何其他与服务有关的协议的行为，或是法律方面另有要求的时候。
      </p>
      <p>
        当您访问的商家指示我们传输这些信息时（例如在他们启用了访问客户个人信息的应用时）。
      </p>
      <p>
        为了符合法律要求，或者响应法定的法院指令、传票和搜查令或者政府当局的其他要求（包括为符合国家安全要求和执法要求的情况）。
      </p>
      <div class="privacy-tit2">
        <strong>5.信息存储和交换</strong>
      </div>
      <p>
        本应用收集的有关您的信息和资料将保存在本应用及（或）其关联公司的服务器上，这些信息和资料可能传送至您所在国家、地区或本应用收集信息和资料所在地的境外并在境外被访问、存储和展示。
      </p>
      <div class="privacy-tit2">
        <strong>6.Cookie的使用</strong>
      </div>
      <p>
        (a)
        在您未拒绝接受cookies的情况下，本应用会在您的计算机上设定或取用cookies
        ，以便您能登录或使用依赖于cookies的本应用平台服务或功能。本应用使用cookies可为您提供更加周到的个性化服务。
      </p>
      <p>
        (b)
        您有权选择接受或拒绝接受cookies。您可以通过修改浏览器设置的方式拒绝接受cookies。但如果您选择拒绝接受cookies，则您可能无法登录或使用依赖于cookies的本应用网络服务或功能。
      </p>
      <p>(c) 通过本应用所设cookies所取得的有关信息，将适用本政策。</p>
      <div class="privacy-tit2">
        <strong>7.信息安全</strong>
      </div>
      <p>
        (a)
        本应用帐号均有安全保护功能，请妥善保管您的用户名及密码信息。本应用将通过对用户密码进行加密等安全措施确保您的信息不丢失，不被滥用和变造。尽管有前述安全措施，但同时也请您注意在信息网络上不存在“完善的安全措施”。
      </p>
      <p>
        (b)
        在使用本应用网络服务进行，您不可避免的要向合作服务方（如物流商，海外仓等）披露自己的个人信息，如联络方式或者邮政地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。
      </p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
/*body*/
.abbody {
  width: 100%;
}
.abcent {
  max-width: 1100px;
  margin: 0 auto;
  overflow: hidden;
  /* min-width: 1100px; */
}
.abcentnav {
  width: 100%;
  height: 80px;
  font-size: 14px;
  color: #666666;
  border-bottom: 1px solid #ccc;
  font-family: "Microsoft Yahei";
}
.abcentnav div {
  width: 1100px;
  height: 100%;
  line-height: 80px;
  margin: 0 auto;
  min-width: 1100px;
}
/*隐私政策*/
.privacy-tit {
  margin-top: 50px;
  margin-bottom: 25px;
  text-align: center;
  font-size: 28px;
  line-height: 1.8;
}
.privacy-mtop20 {
  margin-top: 20px;
}
.privacy-indent {
  text-indent: 2em;
}
.privacy-cent {
  margin-bottom: 56px;
  font-size: 16px !important;
  line-height: 28px;
}
.privacy-cent p {
  /* margin: 0 0 5px; */
  line-height: 1.8;
}
.privacy-tit2 {
  margin-top: 30px;
  margin-bottom: 10px;
  font-weight: bold;
  line-height: 1.8;
}
.privacy-mbtm16 {
  margin-bottom: 16px !important;
}
.privacy-pleft18 {
  padding-left: 18px;
}
strong {
  font-weight: bold;
}
/*隐私政策end*/
</style>